"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _Directions = _interopRequireDefault(require("@material-ui/icons/Directions"));

var _solarReact = require("@solar/solar-react");

var _ProfileItem = _interopRequireDefault(require("../ProfileItem"));

var _UserStatus = _interopRequireDefault(require("../User/UserStatus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var UnitInfo = function UnitInfo(_ref) {
  var unit = _ref.unit,
      onUserClick = _ref.onUserClick,
      onStartOnboarding = _ref.onStartOnboarding,
      onUnitClick = _ref.onUnitClick,
      loading = _ref.loading,
      labels = _ref.labels;
  var contacts = unit.contacts,
      _unit$manufacturer = unit.manufacturer,
      manufacturer = _unit$manufacturer === void 0 ? {
    units: []
  } : _unit$manufacturer,
      location = unit.location;
  var _manufacturer$units = manufacturer.units,
      units = _manufacturer$units === void 0 ? [] : _manufacturer$units,
      mLocation = manufacturer.location;
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, contacts && contacts.length > 0 ? /*#__PURE__*/_react["default"].createElement(_core.List, null, contacts.map(function (_ref2) {
    var avatar = _ref2.avatar,
        fullName = _ref2.fullName,
        _id = _ref2._id,
        email = _ref2.email,
        representative = _ref2.representative;
    return /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], _extends({
      icon: /*#__PURE__*/_react["default"].createElement(_core.Avatar, {
        src: avatar && avatar.src
      }),
      textLabel: labels.responsible,
      text: fullName
    }, representative ? {
      onClick: function onClick() {
        return onUserClick(representative._id);
      }
    } : {}), !representative && !loading && /*#__PURE__*/_react["default"].createElement(_core.Button, {
      disabled: !email,
      variant: "outlined",
      color: "primary",
      onClick: function onClick() {
        return onStartOnboarding(_id);
      }
    }, labels.actions.invite), representative && !loading && /*#__PURE__*/_react["default"].createElement(_UserStatus["default"], {
      invitedAt: representative.invitedAt && 'ok',
      activatedAt: representative.activatedAt && 'ok',
      blocked: representative.blocked,
      activeLabel: labels.status.active,
      blockedLabel: labels.status.blocked,
      notActiveLabel: labels.status.notActive,
      notInvitedLabel: labels.status.notInvited
    }));
  }), /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
    textLabel: location.formatted_address,
    text: labels.address
  }), mLocation.formatted_address !== location.formatted_address && /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
    icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
    textLabel: mLocation.formatted_address,
    text: labels.manufacturer
  })) : '', units.length > 1 && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_solarReact.Header, null, labels.otherUnits), /*#__PURE__*/_react["default"].createElement(_core.List, null, units.map(function (_ref3) {
    var _id = _ref3._id,
        key = _ref3.key,
        uLocation = _ref3.location,
        name = _ref3.name;
    return _id !== unit._id && /*#__PURE__*/_react["default"].createElement(_ProfileItem["default"], {
      icon: /*#__PURE__*/_react["default"].createElement(_Directions["default"], null),
      textLabel: uLocation.formatted_address,
      text: "".concat(key, ". ").concat(name),
      onClick: function onClick() {
        return onUnitClick(_id);
      }
    });
  }))));
};

var _default = UnitInfo;
exports["default"] = _default;